import { clstx } from '@payaca/utilities/cvaMerge';
import React, { FC, useEffect, useState } from 'react';
import InputGroup from '../InputGroup/InputGroup';
import Input, { InputProps } from './Input';

export type NumberInputProps = {
  as?: typeof Input | typeof InputGroup.Input;
  value: number | null;
  onChange?: (quantity: number | null) => void;
} & Omit<InputProps, 'type' | 'value' | 'onChange' | 'step'>;

const NumberInput: FC<NumberInputProps> = (props) => {
  const {
    as: InputComponent = Input,
    value,
    onChange,
    onBlur,
    onWheel,
    inputClassName,
    ...rest
  } = props;

  const [manualQuantity, setManualQuantity] = useState(value?.toString() ?? '');

  // Sync internal string state with external value prop when they diverge,
  // including when the input is empty/invalid but the parent has set a value
  useEffect(() => {
    const manualQuantityAsNumber = parseFloat(manualQuantity);
    const isStale = isNaN(manualQuantityAsNumber)
      ? value != null
      : manualQuantityAsNumber !== value;
    if (isStale) {
      setManualQuantity(value?.toString() ?? '');
    }
  }, [value, manualQuantity]);

  const handleManualQuantityChange = (newValue: string) => {
    let newQuantity: number | null = parseFloat(newValue);

    if (newValue.trim() === '' || isNaN(newQuantity)) {
      newQuantity = null;
    }

    onChange?.(newQuantity);
  };

  return (
    <InputComponent
      type="number"
      inputClassName={clstx('pl-form-input--number', inputClassName)}
      value={manualQuantity}
      onChange={(newManualQuantity) => {
        setManualQuantity(newManualQuantity);
        handleManualQuantityChange(newManualQuantity);
      }}
      onWheel={(e) => {
        onWheel?.(e);
        e.currentTarget.blur();
      }}
      onBlur={onBlur}
      {...rest}
    />
  );
};

export default NumberInput;
